(ns manage.adset-decision-tree-page.view.side-panel.trackers
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Menu$default" :as Menu]
            ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["react-hook-form" :as rhf]
            ["src/svg/arrows/arrow-counter-clockwise.svg$default"
             :as ArrowCounterClockwise]
            [cljs-bean.core :refer [->clj]]
            [common.widgets.form-field :refer [form-field]]
            [manage.adset-decision-tree-page.property :as property]
            [manage.adset-decision-tree-page.tagging-and-trackers.macro-input
             :refer [macro-input]]
            [manage.adset-decision-tree-page.view.common :refer [landing-url-info-tooltip]]
            [manage.adset-decision-tree-page.view.context :as context]
            [manage.adset-decision-tree-page.view.side-panel.property-form
             :refer [get-property-field-name use-property-value use-set-property-value]]
            [manage.adset-decision-tree-page.view.side-panel.util
             :as side-panel.util]
            [manage.adset.hooks :as adset.h]
            [uix.core :as uix :refer [$ defui]]))

(defui tracker-list-item-fields [{:keys [delete-item control get-field-path tracker-type]}]
  ($ rhf/Controller
     {:name (get-field-path "value")
      :control control
      :render (fn [^js props]
                (let [{{:keys [onChange value onBlur]} :field
                       {:keys [error]} :fieldState} (->clj props)]
                  ($ :<>
                     ($ Stack {:direction "row"
                               :gap 2}
                        ($ form-field
                           {:sx #js {:flex 1
                                     :minWidth 0}
                            :label (-> tracker-type {"click" "Click"
                                                     "impression" "Impression"})
                            :data-testid "tracker-param-value-input"
                            :label-action (when (= tracker-type "click")
                                            ($ landing-url-info-tooltip))}
                           ($ macro-input {:value (or value "")
                                           :multi-line? true
                                           :allow-macros? true
                                           :on-change onChange
                                           :on-blur onBlur}))
                        ($ IconButton
                           {:sx #js {:alignSelf "flex-end"}
                            :onClick delete-item
                            :data-testid "delete-tracker-param"}
                           ($ Icon "delete")))
                     (when-some [error-message (:message error)]
                       ($ Stack {:direction "row"
                                 :alignItems "center"
                                 :spacing 1
                                 :sx #js {:my 1
                                          :color "error.main"}}
                          ($ Icon "warning")
                          ($ Typography error-message))))))}))

(defui add-new-tracker-button [{:keys [is-click-tracker-item-enabled
                                       is-impression-item-shown
                                       add-new-click-tracker
                                       add-new-impression-tracker
                                       is-column]}]
  (let [[anchor-element set-anchor-element] (uix/use-state nil)]
    ($ :<>
       ($ Button {:startIcon ($ Icon "add")
                  :variant "text"
                  :onClick (fn [^js event]
                             (set-anchor-element (.-currentTarget event)))
                  :sx #js {:alignSelf "start"}}
          (str "Add new tracker" (when is-column " column")))
       ($ Menu {:anchorEl anchor-element
                :open (some? anchor-element)
                :onClose (fn [^js _event]
                           (set-anchor-element nil))
                :sx #js {:width "100%"}
                :size "small"}
          ($ MenuItem {:disabled (not is-click-tracker-item-enabled)
                       :onClick (fn [^js _event]
                                  (set-anchor-element nil)
                                  (add-new-click-tracker))}
             "Click")
          (when is-impression-item-shown
            ($ MenuItem {:onClick (fn [^js _event]
                                    (set-anchor-element nil)
                                    (add-new-impression-tracker))}
               "Impression"))))))

(defui ad-variant-trackers-editor [{:keys [form-control property]
                                    {:keys [append remove fields]} :field-array}]
  (let [root-node (context/use-property-context property)
        adset-channel (adset.h/use-channel)
        root-trackers-value (get-in root-node property/trackers-data-path)
        trackers-value (->clj (use-property-value form-control property))
        set-trackers-value (use-set-property-value form-control property)]
    ($ side-panel.util/collapsible-wrapper
       {:label "Trackers"
        :collapsed-label (str "Trackers (" (count trackers-value) ")")
        :header-content (if (= trackers-value root-trackers-value)
                          ($ Chip {:label "Inherited"
                                   :size "small"
                                   :sx #js {:mr 1}})
                          ($ Button {:startIcon ($ ArrowCounterClockwise {:width 20
                                                                          :height 20})
                                     :onClick (partial set-trackers-value
                                                       (clj->js root-trackers-value))}
                             "Reset values"))}
       ($ Stack {:direction "column"
                 :spacing 2}
          (map-indexed
           (fn [index ^js field]
             (let [get-field-path (partial get-property-field-name property (str index))]
               ($ tracker-list-item-fields
                  {:key (.-id field)
                   :control (:control form-control)
                   :get-field-path get-field-path
                   :delete-item (partial remove index)
                   :tracker-type (.-type field)})))
           fields)
          ($ add-new-tracker-button
             {:is-click-tracker-item-enabled (not (some (comp #{"click"} :type)
                                                        trackers-value))
              :is-impression-item-shown (not= adset-channel "meta")
              :add-new-click-tracker (partial append #js {:type "click" :value ""})
              :add-new-impression-tracker (partial append
                                                   #js {:type "impression" :value ""})})))))
